declare var $device: any
var d: any, desktopAppCookie, n, platform, property, ref, ref1, ref2, ref3, ua, value, variants, versionMatch

if (typeof $device !== 'undefined') {
  d = $device
} else {
  d = {}
  n = navigator
  ua = navigator.userAgent.toLowerCase()
  platform = n.platform.toLowerCase()
  // gadgets
  d.ipad = ua.indexOf('ipad') >= 0
  d.iphone = ua.indexOf('iphone') >= 0
  d.ipod = ua.indexOf('ipod') >= 0
  // operating systems
  d.ios = d.ipad || d.iphone || d.ipod
  d.android = ua.indexOf('android') >= 0
  d.windowsPhone = ua.indexOf('windows phone') >= 0
  d.mac = platform.match(/^mac/) !== null
  d.windows = platform.indexOf('win') === 0
  d.webos = ua.indexOf('webos') >= 0
  d.blackberry = ua.indexOf('blackberry') >= 0
  d.windowsTouch = !!window.ontouchstart || (window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 0)
  // browsers
  d.edge = ua.indexOf('chrome') >= 0 && ua.indexOf('edge/') >= 0
  d.chrome = !d.edge && ua.indexOf('chrome') >= 0
  d.firefox = ua.indexOf('firefox') >= 0
  d.ie = ua.indexOf('msie') >= 0 || (n.appName === 'Netscape' && ua.indexOf('trident') >= 0)
  d.webkit = ua.indexOf('webkit') >= 0
  d.safari = !!(<any>window).safari || ((ref = navigator.vendor) != null ? ref.indexOf('Apple') : void 0) >= 0
  d.ie11 = ua.indexOf('rv:11.0') >= 0
  d.ie10 = ua.indexOf('msie 10.0') >= 0
  versionMatch = ua.match(/(?:version|chrome|firefox)\/(.*?)(?:$|\s)/)
  if (versionMatch) {
    d.version = parseFloat(versionMatch[1])
  } else {
    d.version = 0
  }
  // hardware
  d.iphoneX = d.ios && (window.screen.width === 812 || window.screen.height === 812)
  // type
  d.mobile = d.ios || d.android || d.windowsPhone || d.blackberry
  d.desktop = !d.mobile
  d.supported = !d.ie && (!d.safari || d.version > 9.0)
  // capability
  d.touchable = d.ios || d.android || d.webos || d.blackberry || d.windowsTouch
  d.mousable = !d.touchable || d.windowsTouch // for now
  d.retina = window.devicePixelRatio !== void 0 && window.devicePixelRatio > 1
  d.clickGesture = d.touchable ? 'tap' : 'click'
  d.dragFile = !d.touchable
  d.cookies = navigator.cookieEnabled
  // variant
  variants =
    ((ref1 = document.body.getAttribute('ww-app-variant')) != null ? ref1.split(' ') : void 0) ||
    ((ref2 = document.documentElement.getAttribute('data-variant')) != null ? ref2.split(' ') : void 0)
  desktopAppCookie = decodeURIComponent(
    (ref3 = RegExp('ww_da' + '[^;]+').exec(document.cookie)) != null ? ref3.toString().replace(/^[^=]+./, '') : void 0,
  )
  if (variants) {
    d.tablet = variants.indexOf('tablet') > -1
    d.phone = variants.indexOf('phone') > -1
    d.iosApp = variants.indexOf('ios') > -1
    d.androidApp = variants.indexOf('android') > -1
  } else {
    d.tablet = false
    d.phone = false
    d.iosApp = false
    d.androidApp = false
  }
  d.app = d.iosApp || d.androidApp
  d.desktopApp =
    (desktopAppCookie && desktopAppCookie !== 'undefined') || (!!variants && variants.indexOf('desktopapp') > -1)
  d.electron = desktopAppCookie === 'other'
  d.nwjs = desktopAppCookie === 'nwjs'
  d.safariPush = window && (<any>window).safari && (<any>window).safari.pushNotification
  d.webPush = window && (<any>window).PushManager
  d.browserPush = d.safariPush || d.webPush
  for (property in d) {
    value = d[property]
    if (value === true) {
      document.documentElement.classList.add(property)
    }
  }
}

export default d
